// extracted by mini-css-extract-plugin
export var footer = "_oq-5";
export var fulfillmentInput = "_oq-0";
export var shipDateInput = "_oq-1";
export var shipmentModal = "_oq-2";
export var shipmentModalContent = "_oq-3";
export var tableContainer = "_oq-4";